// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__2E6Q-","card":"styles_card__2IqTh","text":"styles_text__2pwSo"};